import { PasswordInput, PasswordInputProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormPasswordFieldProps<Values = Record<string, unknown>>
  extends PasswordInputProps,
    IFocusableFormField<Values> {}

export const FormPasswordField: <Values = Record<string, unknown>>(
  props: IFormPasswordFieldProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const elementRef = useRef<HTMLInputElement>(null);
  parentForm.registerField(fieldName, elementRef);
  return (
    <PasswordInput
      {...rest}
      {...parentForm.getInputProps(fieldName)}
      ref={elementRef}
    />
  );
};
